import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import { useSelector } from 'react-redux';
import VideoRequester from 'shared/VideoRequester';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';

const useHlsStream = (videoRef, streamUrl, token) => {
  useEffect(() => {
    const videoRequester = new VideoRequester();
    

    videoRequester.setAuthTokenHeader(`Bearer ${token}`);

    videoRequester.get(streamUrl)
      .then((response) => {
        if (Hls.isSupported() && response) {
          const hls = new Hls({
            xhrSetup: (xhr, url) => {
              xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            }
          });

          hls.loadSource(streamUrl);
          hls.attachMedia(videoRef.current);

          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            
            if (videoRef.current.paused) {
              videoRef.current.play().catch((error) => {
                console.error("Error attempting to play video:", error);
              });
            }
          });

          hls.on(Hls.Events.ERROR, function (event, data) {
            console.error("HLS.js Error for stream:", streamUrl, data);
            if (data.fatal) {
              switch (data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  console.error("Network error for stream:", streamUrl);
                  hls.startLoad();  // 네트워크 오류 복구
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  console.error("Media error for stream:", streamUrl);
                  hls.recoverMediaError();  // 미디어 오류 복구
                  break;
                default:
                  console.error("Unrecoverable error for stream:", streamUrl);
                  hls.destroy();  // 복구 불가능한 경우 HLS 인스턴스 파괴
                  break;
              }
            }
          });

        } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
          
          videoRef.current.src = streamUrl;
          videoRef.current.addEventListener('loadedmetadata', () => {
            if (videoRef.current.paused) {
              videoRef.current.play().catch((error) => {
                console.error("Error attempting to play video:", error);
              });
            }
          });
        }
      })
      .catch((error) => {
        console.error('Failed to load video stream:', streamUrl, error);
      });

  }, [streamUrl, token]);
};

const VideoPlayer = ({ streamType }) => {
  const videoRef = useRef(null);
  const { token } = useSelector((state) => ({
    token: state.auth.token,
  }));

  // streamType에 따라 스트림 URL을 동적으로 설정
  const streamUrl = `http://175.213.135.218:18000/${streamType}/index.m3u8`;

  // 공통 HLS 로직을 실행하는 커스텀 훅
  useHlsStream(videoRef, streamUrl, token);

  return <video ref={videoRef} controls width="600" muted playsInline />;
};

const MultiStreamPlayer = () => {
  return (
    <div>
      <VerticalFlex gap={10}>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild>
              <h2>Stream 1</h2>
              <VideoPlayer streamType="stream" /> {/* stream1 디렉토리에서 요청 */}
            </FlexChild>
            <FlexChild>
              <h2>Stream 2</h2>
              <VideoPlayer streamType="stream2" /> {/* stream2 디렉토리에서 요청 */}
            </FlexChild>


          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild>
              <h2>Stream 3</h2>
              <VideoPlayer streamType="stream3" /> {/* stream2 디렉토리에서 요청 */}
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
};

export default MultiStreamPlayer;